export default __webpack_public_path__ + "static/img-schroders-distribution-datathon-05e294b507b254ab87a9dfc852eebf8c.webp";